import { Direcciones } from '../../../entities/Direcciones';
import { Component } from '@angular/core';
import { AuthServiceService } from '../login/services/auth-service.service';
import { User } from '../../../entities/User';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { DireccionesService } from '../direcciones/services/direcciones.service';

@Component({
  selector: 'app-panel-usuario',
  templateUrl: './panel-usuario.component.html',
  styleUrls: ['./panel-usuario.component.scss']
})
export class PanelUsuarioComponent {
  public openDashboard: boolean = false;
  public direccion: Direcciones;
  public showInfovacio: boolean = false;
  public usuario:User;
  constructor(private auth:AuthServiceService, private location: Location, private route:Router, private direccionService:DireccionesService) { }

  ngOnInit(): void {
    this.obtenerDireccionPredeterminada()
    this.usuario = this.auth.getUser();
  }

  obtenerDireccionPredeterminada(){
    this.direccionService.obtenerDireccionPredeterminada().subscribe((result: Direcciones) => {
      this.direccion = result
      if(this.direccion == null){
        this.showInfovacio = true;
      }
    })
  }

  ToggleDashboard() {
    this.openDashboard = !this.openDashboard;
  }

  irWishList(){
    this.route.navigateByUrl('/pages/wishlist')
  }

  irCambiarContrasena(){
    this.route.navigateByUrl('/pages/cambiar-contrasena')
  }

  irPerfil(){
    this.route.navigateByUrl('/pages/perfil')
  }

  irDirecciones(){
    this.route.navigateByUrl('/pages/direcciones')
  }

  irDatosFacturacion(){
    this.route.navigateByUrl('/pages/datos-facturacion')
  }

  agregarDireccion(){
    this.route.navigateByUrl('/pages/agregar-direccion')
  }

  editarDireccion(data){
    this.route.navigateByUrl('/pages/editar-direccion/' + data.id)
  }

  metodosPago(){
    this.route.navigateByUrl('/pages/listar-metodo-pago')
  }

  irMisPedidos(){
    this.route.navigateByUrl('/pages/pedidos')

  }
  logout(){
    this.auth.logout();
    this.location.replaceState('/home/watch');
    window.location.reload();
  }
}
